import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './style.module.scss';

const PageTitleHeader = ({
  title,
  className = '',
  isEnableDataCsMask = false
}) => {
  return (
    <h1
      className={cx('text-uppercase h1', className, style['title__border'])}
      data-cs-mask={isEnableDataCsMask}
    >
      {title}
    </h1>
  );
};

PageTitleHeader.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
  isEnableDataCsMask: PropTypes.bool
};

export default PageTitleHeader;
